import { render, staticRenderFns } from "./amostrastatus.vue?vue&type=template&id=81ac4ee2"
import script from "./amostrastatus.vue?vue&type=script&lang=js"
export * from "./amostrastatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports